
import {  Checkbox, Dialog, Divider, FormControlLabel } from '@mui/material';
import { debounce, pick } from 'lodash-es';
import React,{  useState } from 'react';
import { BsTrash } from 'react-icons/bs';
import { showToastMessage } from 'src/coach/service/coach.utils';
import { Button, SelectField, TextArea } from 'src/shared';
import { actionsOnConflict } from '../helpers';
import { EventDateConflicts } from './event-date-conflicts';
import './notify-selection.module.scss';


const CoachItem = ({
  coach,
  coachesConflicts,
  handleCoachActionOnConflictChange,
  handleCoachDelete,
  handleCoachRoleChange,
  handleCoachShowOnDetailsChange,
  participantRoles,
  showCheckboxCoachOnDetails = false,
}) => {
  const currentCoachConflicts = coachesConflicts[coach?.id];
  return (
    <div className={"coachItemContainer"}>
      <div className={"coachItem"} key={coach.id}>
        <p className={"title"}>{coach?.fullName}</p>
        <SelectField
          id={coach.id}
          onChange={(e) => handleCoachRoleChange(e.target.value, coach)}
          value={coach?.roleId}
        >
          <option disabled selected>
            Select coach role
          </option>
          {participantRoles.map((option) => (
            <option key={option.id} value={option.id}>
              {option.title}
            </option>
          ))}
        </SelectField>
        <div className={"delIcon"} onClick={() => handleCoachDelete(coach)}>
          <BsTrash />
        </div>
      </div>
      <EventDateConflicts
        coachId={coach?.id}
        coachesConflicts={coachesConflicts}
        fontSize={14}
      />

      {currentCoachConflicts?.conflictingDates?.length > 0 && (
        <SelectField
          id={coach.id}
          onChange={(e) =>
            handleCoachActionOnConflictChange(e.target.value, coach)
          }
          style={{ marginBottom: '8px', marginTop: '8px' }}
          value={coach?.actionOnConflict}
        >
          <option disabled selected>
            Select action on conflict
          </option>

          {actionsOnConflict.map((option) => {
            return (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            );
          })}
        </SelectField>
      )}
      {showCheckboxCoachOnDetails && (
        <FormControlLabel
       control={ <Checkbox/>}
         checked={coach?.showCoachOnDetails}
          label="Show coach on class details & search pages"
          onChange={(e) =>
            handleCoachShowOnDetailsChange(e.target.checked, coach)
          }
          />
      )}
    </div>
  );
};
export const NotifySelection = ({
  coachesConflicts,
  defaultRole,
  onClose = () => {},
  onSubmit = () => {},
  participantRoles = [],
  selectedCoaches,
  showCheckboxCoachOnDetails,
  open,
}) => {
  const [notifyOptions, setNotifyOptions] = useState([
    {
      comment: '',
      id: 4,
      text: 'Admins',
      value: false,
    },
    {
      comment: '',
      id: 0,
      text: 'The assigned individual ',
      value: false,
    },
    {
      comment: '',
      id: 3,
      text: 'Other staff assigned to these events',
      value: false,
    },
    { comment: '', id: 2, text: 'Parents/Participants', value: false },
    { comment: '', id: 1, text: 'Location Contacts', value: false },
  ]);

  const [assignedStaff, setAssignedStaff] = useState(
    selectedCoaches.map((coach) => ({
      ...pick(coach, [
        'id',
        'firstName',
        'lastName',
        'phone',
        'email',
        'fullName',
        'nickName',
      ]),
      actionOnConflict: 'REMOVE_FROM_CONFLICTED_DATES',
      assigneeId: coach.id,
      roleId: defaultRole?.id ?? participantRoles?.[0]?.id,
      roleType: defaultRole?.title ?? participantRoles?.[0]?.title,
      showCoachOnDetails: showCheckboxCoachOnDetails,
    })),
  );
  const getNotifyToOptions = () => {
    const notify = [...notifyOptions];
    return notify
      .filter((element) => element.value)
      .map((op) => {
        return {
          comment: op.comment ?? '',
          notifyTo: [op.id],
        };
      });
  };

  const handleChange = (index, key, value) => {
    const updatedOptions = [...notifyOptions];
    updatedOptions[index][key] = value;
    setNotifyOptions(updatedOptions);
  };

  const handleCoachRoleChange = (value, coach) => {
    const role = participantRoles.find((item) => item.id === value);
    const updatedStaff = [...assignedStaff];
    const index = updatedStaff.findIndex((item) => item.id === coach.id);
    updatedStaff[index].roleId = value;
    updatedStaff[index].roleType = role?.title;
    setAssignedStaff(updatedStaff);
  };
  const handleCoachDelete = (coach) => {
    const updatedStaff = assignedStaff.filter((item) => item.id !== coach.id);
    setAssignedStaff(updatedStaff);
  };

  const handleCoachActionOnConflictChange = (value, coach) => {
    const updatedStaff = [...assignedStaff];
    const index = updatedStaff.findIndex((item) => item.id === coach.id);
    updatedStaff[index].actionOnConflict = value;
    setAssignedStaff(updatedStaff);
  };
  const handleCoachShowOnDetailsChange = (value, coach) => {
    const updatedStaff = [...assignedStaff];
    const index = updatedStaff.findIndex((item) => item.id === coach.id);
    updatedStaff[index].showCoachOnDetails = value;
    setAssignedStaff(updatedStaff);
  };

  const debouncedHandleNameChange = debounce(handleChange, 0);

  return (
    <Dialog maxWidth="sm" onClose={onClose} open={open}>
      <div className={"coachAssignmentActionContainer"}>
        <div className={"actionsContainer"}>
          <h4>Staff Coaches</h4>

          {assignedStaff?.map((coach) => (
            <>
              <CoachItem
                coach={coach}
                coachesConflicts={coachesConflicts}
                handleCoachActionOnConflictChange={
                  handleCoachActionOnConflictChange
                }
                handleCoachDelete={handleCoachDelete}
                handleCoachRoleChange={handleCoachRoleChange}
                handleCoachShowOnDetailsChange={handleCoachShowOnDetailsChange}
                key={coach.id}
                participantRoles={participantRoles}
                showCheckboxCoachOnDetails={showCheckboxCoachOnDetails}
              />
              <Divider />
            </>
          ))}
        </div>
        <div className={"actionsContainer"}>
          <h4>Notify</h4>
          {notifyOptions.map((item, index) => {
            return (
              <div
                className={"coachAssignmentActionCheckBox"}
                key={item.id}
              >
                 <FormControlLabel control={<Checkbox  />} 
                  label={item.text}
                  onChange={(event) =>
                    debouncedHandleNameChange(
                      index,
                      'value',
                      event.target.checked,
                    )
                  }/>
               
                {item.value && (
                  <TextArea
                    className={"coachAssignmentActionInput"}
                    disabled={!item.value}
                    onChange={(event) =>
                      debouncedHandleNameChange(
                        index,
                        'comment',
                        event.target.value,
                      )
                    }
                    placeholder="Add message here"
                    rows={1}
                    value={item.comment}
                  />
                )}
              </div>
            );
          })}
        </div>
        <div>
          <div className="bottomActions tw-gap-2">
            <Button
              onClick={() => onClose({ clean: false })}
              className="tw-bg-white  tw-text-red tw-border-red"
            >
              Cancel
            </Button>
            <Button
              disabled={assignedStaff.length === 0}
              onClick={() => {
                if (assignedStaff?.some((staff) => !staff?.roleId)) {
                  showToastMessage('Please select role for all staff', 'error');
                  return;
                }
                onClose({ clean: true });
                onSubmit({
                  assignedStaff: assignedStaff.map((staff) => ({
                    ...staff,
                    actionOnConflict: staff.actionOnConflict,
                    conflictDateIds: coachesConflicts[
                      staff?.id
                    ]?.conflictingDates?.map((date) => date?.id),
                    roleId: staff.roleId,
                  })),
                  notifications: getNotifyToOptions(),
                });
              }}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
